import React from "react";

export default function NotFound() {
  return <div>잘못된 주소입니다.</div>;
}
